<template>
  <FullPageLayout>
    <template v-if="fetchState.pending">
      <div>loading...</div>
    </template>
    <template v-else-if="fetchState.error">
      <ErrorPageLayout :error="fetchState.error" />
    </template>
    <template v-else>
      <div class="mx-auto w-full h-full flex-1 flex flex-col mb-15 max-w-[1100px] bg-white">
        <ProfileCover v-if="!isMobile || !isFollowPage" />
        <div class="w-full h-full">
          <ProfileInformation v-if="!isMobile || !isFollowPage">
            <ProfileAction />
          </ProfileInformation>
          <ProfileTab v-if="!blocked && !blockedMe" />
          <div v-if="blocked || blockedMe" class="sm:mt-8 sm:mb-20 w-full flex-col u-center">
            <OImage loading="lazy" src="/images/not-found.svg" class="max-w-56 max-h-56" />
            <div class="font-bold text-lg mt-8">{{ blockedMe ? $t('profile.blocked-me') : $t('profile.blocked') }}</div>
            <div class="font-medium text-lg text-center mt-2 max-w-96">{{ $t('profile.blocked-msg') }}</div>
          </div>
        </div>
      </div>
    </template>
  </FullPageLayout>
</template>
<script>
import { defineComponent, useContext, useFetch, useRoute, computed } from '@nuxtjs/composition-api';
import { useProfileMeta } from '@/modules/profile/utils/profileMeta';
import FullPageLayout from '@/modules/common/components/layout/FullPageLayout';
import ErrorPageLayout from '@/modules/common/components/layout/ErrorPageLayout.vue';
import ProfileCover from '@/modules/profile/components/ProfileView/ProfileCover';
import ProfileInformation from '@/modules/profile/components/ProfileView/ProfileInformation';
import ProfileTab from '@/modules/profile/components/ProfileView/ProfileTab';
import ProfileAction from '@/modules/profile/components/ProfileView/ProfileAction';
import { isEmpty } from 'lodash';
import { useDevice } from '@/composables/useDevice';
import { FOLLOWERS_PATH, FOLLOWINGS_PATH } from '~/constants/config';
import { installProfileContext, useProfile } from '~/modules/profile/state/useProfile';
import { OImage } from '~/modules/common/components/ui';

export default defineComponent({
  components: {
    FullPageLayout,
    ErrorPageLayout,
    ProfileCover,
    ProfileInformation,
    ProfileTab,
    ProfileAction,
    OImage,
  },
  head: {
    bodyAttrs: {
      class: 'bg-[#f7f8fb] o-ps-global',
    },
  },
  middleware: 'profileRedirect',
  setup() {
    installProfileContext();
    const route = useRoute();
    const { $error, $cache } = useContext();
    const { state, getUser } = useProfile();
    const username = route.value.params.username;

    $cache('public, max-age=30');

    const { fetchState } = useFetch(async () => {
      try {
        await getUser(username);
        if (isEmpty(state.value.user)) {
          $error('User not found', 404, false);
        }
      } catch (error) {
        $error(error);
      }
    });
    useProfileMeta({ userData: state });

    const { isMobile } = useDevice();
    const isFollowPage = computed(() => route.value.path.includes(FOLLOWERS_PATH) || route.value.path.includes(FOLLOWINGS_PATH));
    const blocked = computed(() => state.value.user?.blockStatus);
    const blockedMe = computed(() => state.value.user?.blocked);

    return {
      state,
      username,
      fetchState,
      isMobile,
      isFollowPage,
      blocked,
      blockedMe,
    };
  },
});
</script>
